import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import { useCallback, useEffect, useState } from 'react';
import { queryFeatureLayer } from '../arcgis/jsapi/js-api-util';

// Map Filter state.
const useFilters = (layer: FeatureLayer, fieldNames: string[]): any[] => {
    const [filterFields, setFilterFields] = useState<any[]>([]);
    const [filterFieldName, setFilterFieldName] = useState<string>('');
    const [filterFieldValues, setFilterFieldValues] = useState<string[]>([]);
    const [filterFieldValue, setFilterFieldValue] = useState<string>('--');

    // layer changed
    useEffect(() => {
        if (fieldNames?.length > 0 && layer !== undefined) {
            const arrFields = layer?.fields?.filter(
                (fld: any) => fieldNames.indexOf(fld.name) !== -1
            );

            if (arrFields.length > 0) {
                setFilterFields(arrFields);
                setFilterFieldName((prevName: string) => {
                    const field =
                        arrFields.find((fld: any) => fld.name === prevName) ??
                        arrFields[0];
                    return field.name;
                });
            } else {
                setFilterFields([]);
                setFilterFieldName('');
            }
        }
    }, [fieldNames, layer]);

    // FilterFieldName changed.
    useEffect(() => {
        const onFilterFieldNameChanged = async () => {
            const response = await queryFeatureLayer({
                layer: layer,
                outFields: [filterFieldName],
                orderByFields: `${filterFieldName} ASC`,
                returnDistinctValues: true
            });
            const arrValues = response.features.map(
                (f: any) => f.attributes[filterFieldName]
            );
            setFilterFieldValues(arrValues);
        };
        if (layer !== undefined && filterFieldName !== '')
            onFilterFieldNameChanged();
    }, [filterFieldName, layer]);

    // FilterFieldValues changed.
    useEffect(() => {
        if (filterFieldValues.length > 0) {
            setFilterFieldValue((prevValue: string) => {
                const value =
                    filterFieldValues.find(
                        (val: string) => val === prevValue
                    ) ?? '--';
                return value;
            });
        }
    }, [filterFieldValues]);

    const clearFilter = useCallback(() => {
        setFilterFieldValue('--');
    }, [setFilterFieldValue]);

    return [
        filterFields,
        filterFieldName,
        filterFieldValues,
        filterFieldValue,
        setFilterFieldName,
        setFilterFieldValue,
        clearFilter
    ];
};
export default useFilters;
